module.exports = __webpack_public_path__ + "img/couples-040.ca585634.jpg";